import { createFileRoute } from "@tanstack/react-router";
import { DeskPage } from "../../../components/desk/desk-page";
import { deskSearch } from "../../../lib/desk/search";

/** Award medals: decided medal events not yet settled (`GET /medals/pending`). */
export const Route = createFileRoute("/_app/award/")({
	validateSearch: deskSearch,
	component: function PendingDesk() {
		const search = Route.useSearch();
		return <DeskPage list="pending" search={search} />;
	},
});
